import React from 'react';
import { Col, ControlLabel, Row } from 'react-bootstrap';
import MdPeople from 'react-icons/lib/md/people';
import MdPerson from 'react-icons/lib/md/person';
import cx from 'classnames';
import { Button } from '../../../../../../../../common/components';
import './GroupType.scss';

const Adult = ({ children }) => <span className={'adult'}>{children}</span>;

const Individual = () => (
  <Adult>
    <MdPerson />
  </Adult>
);

const Couple = () => (
  <>
    <Adult>
      <MdPeople />
    </Adult>
  </>
);
const Spf = () => (
  <>
    <Adult>
      <MdPerson />
    </Adult>
    <MdPeople />
  </>
);

const Family = () => (
  <>
    <Adult>
      <MdPeople />
    </Adult>
    <MdPeople />
  </>
);

const Icons = {
  individual: Individual,
  couple: Couple,
  spf: Spf,
  family: Family,
};

const GroupTypes = {
  individual: 'Individual',
  couple: 'Individual + Partner',
  spf: 'Individual + Children',
  family: 'Family',
};

const GroupTypeButton = ({
  groupType,
  groupTypeLabel,
  onSelectGroupType,
  isSelected,
}) => {
  const handleGroupType = () => onSelectGroupType(groupType);
  const Icon = Icons[groupType];

  return (
    <Button
      handleClick={handleGroupType}
      className={cx({
        'button-selected': isSelected,
      })}
      label={
        <span className={'icons'}>
          <Icon />
          {groupTypeLabel}
        </span>
      }
      bsStyle={'group-type'}
    />
  );
};
const GroupType = ({ input, meta }) => {
  const handleSelectGroupType = (groupType) => {
    input.onChange(groupType);
  };
  const groupTypeKeys = Object.keys(GroupTypes);
  return (
    <>
      <Row className={'group-type'}>
        <Col xs={12} sm={12} md={3} lg={2} xl={1}>
          <ControlLabel>Who will require cover?</ControlLabel>
        </Col>
        <Col xs={12} sm={12} md={9} lg={10} xl={11}>
          {groupTypeKeys.map((groupTypeKey) => (
            <GroupTypeButton
              isSelected={input.value === groupTypeKey}
              groupType={groupTypeKey}
              groupTypeLabel={GroupTypes[groupTypeKey]}
              onSelectGroupType={handleSelectGroupType}
            />
          ))}
        </Col>
      </Row>
      <Row>
        <Col smOffset={4}>
          {meta && meta.touched && meta.error && (
            <span className="input-error">{meta.error}</span>
          )}
        </Col>
      </Row>
    </>
  );
};

export default GroupType;
